import { render, staticRenderFns } from "./updateForm.vue?vue&type=template&id=7685adc2&scoped=true&"
import script from "./updateForm.vue?vue&type=script&lang=js&"
export * from "./updateForm.vue?vue&type=script&lang=js&"
import style0 from "./updateForm.vue?vue&type=style&index=0&id=7685adc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685adc2",
  null
  
)

export default component.exports